/* eslint-disable jsx-a11y/alt-text */
import axios from "axios";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/Playstream-icon.png";
import illustration from "../../assets/illustration.png"
import "../../App.css"

export const UserLogin = (props) => {
  // const [isLoading, setIsLoading] = React.useState(true);
  const signin = props.signin;
  const { register, handleSubmit, reset } = useForm();
  const navigate = useNavigate();

  const submit = (data) => {
    console.log("submitting form");
    console.log(data);
    axios
      .post("/api/auth/login", data)
      .then((res) => {
        console.log(res.data);
        const tokenToSet = res.data ? res.data.token : "";
        sessionStorage.setItem(
          "userToken",
          tokenToSet.substring(7, tokenToSet.length)
        );
        sessionStorage.setItem("role", res.data.role);

        signin();
        console.log("gotten data");

        navigate("/feeds");
      })
      .catch((err) => {
        alert("user not found....");
        navigate("/");
      });
    reset();
  };



  useEffect(() => {
    sessionStorage.clear();
  }, []);


  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setIsLoading(false); // Set isLoading to false after 2 seconds
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, []);


  return (
    <div className={"mt-3"}>
      <main className="main-content">
        <img className="playstream-logo  align-items-center"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "auto",
          marginLeft: "auto",
          marginRight: "auto",
          margin:"auto",
          justifyContent: "center",
          alignItems: "center",
        }}
            src={logo}>
            </img>
            
       <div className="flex-span">
          <img className="logo-icon row justify-content-center mb-4"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "auto",
          marginLeft: "auto",
          marginRight: "auto",
          margin:"auto",
          justifyContent: "center",
          alignItems: "center",
        }}
            src={illustration}>
            </img>
           
          <span className="" />
          <div className="sign-in-box container-fluid my-auto">
            <div className="row justify-content-center w-100 h-100 justify-content-center w-80 h-80 mx-auto mb-4">
              <div className="col-lg-8 col-md-8 row justify-content-center custom-center">
                <div className="card z-index-0 fadeIn3 fadeInBottom">
                  <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                    <div className="bg-gradient-info shadow-info border-radius-lg py-3 pe-1">
                      <h4 className="text-white font-weight-bolder text-center mt-2 mb-0">
                        Sign in
                      </h4>
                    </div>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit(submit)}>
                      <div className="input-group input-group-outline my-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Username"
                          {...register("username")}
                        />
                      </div>
                      <div className="input-group input-group-outline mb-3">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Password"
                          {...register("password")}
                        />
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn bg-gradient-info w-100 my-4 mb-2"
                        >
                          Sign in
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};